import { render, staticRenderFns } from "./MitSpacesMap.vue?vue&type=template&id=2fbdfef1&scoped=true"
import script from "./MitSpacesMap.vue?vue&type=script&lang=js"
export * from "./MitSpacesMap.vue?vue&type=script&lang=js"
import style0 from "./MitSpacesMap.vue?vue&type=style&index=0&id=2fbdfef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbdfef1",
  null
  
)

export default component.exports